import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=a6f631d4&scoped=true"
import script from "./FormGroup.js?vue&type=script&lang=js&external"
export * from "./FormGroup.js?vue&type=script&lang=js&external"
import style0 from "./FormGroup.scss?vue&type=style&index=0&id=a6f631d4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f631d4",
  null
  
)

export default component.exports